import { render, staticRenderFns } from "./AccountTagFilter.vue?vue&type=template&id=a13734ce"
import script from "./AccountTagFilter.vue?vue&type=script&lang=ts"
export * from "./AccountTagFilter.vue?vue&type=script&lang=ts"
import style0 from "./AccountTagFilter.vue?vue&type=style&index=0&id=a13734ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports